import { useEffect, useState } from 'react';
import { renderHTML } from '../../Utils';
import { SitePage } from '../../Models/SitePage';
import SitePageApi from '../../Api/SitePageApi';
import Loader from '../Common/Loader';
// import { useParams } from 'react-router-dom';
import { PageType } from '../../Enums/PageType';
import { Form } from 'react-router-dom';
import { Button, TextInput, Textarea } from 'flowbite-react';
import { ContactForm } from '../../Models/ContactForm';
import ContactFormApi from '../../Api/ContactFormApi';
import { toast } from 'react-toastify';

export default function Contact() {
  //   const { id } = useParams();
  //   const { userModel } = useAppSelector((state) => state.user);
  const [pageData, setPageData] = useState<SitePage>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);
  const [formData, setFormData] = useState<ContactForm>({
    id: 0,
    companyName: '',
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    subject: '',
    questionsComments: '',
    clientId: null,
    contactId: null,
  });

  useEffect(() => {
    //   getSitePages();
    getSitePage();
    handleSetInitialValues();
  }, []);
  const getSitePage = () => {
    try {
      setIsLoading(true);
      return SitePageApi.getSitePageByPageType(PageType.Contact.toString())
        .then((res) => {
          setPageData(res.data);
          setIsLoading(false);
        })
        .catch((err) => {});
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  const handleSetInitialValues = () => {
    const values = formData
      ? {
          ...formData,
        }
      : {
          id: 0,
          companyName: '',
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          subject: '',
          questionsComments: '',
          clientId: null,
          contactId: null,
        };

    setFormData(values as ContactForm);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleChangeTA = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = () => {
    setButtonDisabled(true);
    try {
      setIsLoading(true);
      return ContactFormApi.addContactForm(formData)
        .then((res) => {
          toast.success('success');
          setIsLoading(false);
          setButtonDisabled(false);
        })
        .catch((err) => {
          toast.error('Error: ' + err);
          setIsLoading(false);
          setButtonDisabled(false);
        });
    } catch (error) {
      console.error(error);
      setIsLoading(false);
      setButtonDisabled(false);
    }
  };

  return (
    <>
      {/* <title>{pageData?.title}</title> */}
      {/* <metadata>{pageData?.metaData}</metadata> */}
      <div className='w-full xl:w-1/2 p-5 mx-auto'>
        <h5 className='text-gray-900 font-bold text-4xl mb-4'>
          {pageData?.header}
        </h5>
        <div>
          <form onSubmit={handleSubmit}>
            <div className='text-gray-500'>
              <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] text-xl'>
                <div className='flex'>
                  <div className='px-1 content-center'>
                    {/* <MdSubscriptions style={iconstyle} /> */}
                  </div>
                  <div className='font-bold content-center'>Company Name:</div>
                </div>
                <div className='flex'>
                  <div className='w-full'>
                    <TextInput
                      id='companyName'
                      name='companyName'
                      type='text'
                      placeholder='Company Name...'
                      onChange={handleChange}
                      value={formData.companyName ?? ''}
                      sizing='md'
                      required
                    />
                  </div>
                </div>
              </div>
              <hr className='bg-gray-300 h-[2px]'></hr>
              <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] text-xl'>
                <div className='flex'>
                  <div className='px-1 content-center'>
                    {/* <MdSubscriptions style={iconstyle} /> */}
                  </div>
                  <div className='font-bold content-center'>First Name:</div>
                </div>
                <div className='flex'>
                  <div className='w-full'>
                    <TextInput
                      id='firstName'
                      name='firstName'
                      type='text'
                      placeholder='First Name...'
                      onChange={handleChange}
                      value={formData.firstName ?? ''}
                      sizing='md'
                      required
                    />
                  </div>
                </div>
              </div>
              <hr className='bg-gray-300 h-[2px]'></hr>
              <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] text-xl'>
                <div className='flex'>
                  <div className='px-1 content-center'>
                    {/* <MdSubscriptions style={iconstyle} /> */}
                  </div>
                  <div className='font-bold content-center'>Last Name:</div>
                </div>
                <div className='flex'>
                  <div className='w-full'>
                    <TextInput
                      id='lastName'
                      name='lastName'
                      type='text'
                      placeholder='Last Name...'
                      onChange={handleChange}
                      value={formData.lastName ?? ''}
                      sizing='md'
                      required
                    />
                  </div>
                </div>
              </div>
              <hr className='bg-gray-300 h-[2px]'></hr>
              <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] text-xl'>
                <div className='flex'>
                  <div className='px-1 content-center'>
                    {/* <MdSubscriptions style={iconstyle} /> */}
                  </div>
                  <div className='font-bold content-center'>Phone:</div>
                </div>
                <div className='flex'>
                  <div className='w-full'>
                    <TextInput
                      id='phone'
                      name='phone'
                      type='text'
                      placeholder='Phone...'
                      onChange={handleChange}
                      value={formData.phone ?? ''}
                      sizing='md'
                    />
                  </div>
                </div>
              </div>
              <hr className='bg-gray-300 h-[2px]'></hr>
              <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] text-xl'>
                <div className='flex'>
                  <div className='px-1 content-center'>
                    {/* <MdSubscriptions style={iconstyle} /> */}
                  </div>
                  <div className='font-bold content-center'>Email:</div>
                </div>
                <div className='flex'>
                  <div className='w-full'>
                    <TextInput
                      id='email'
                      name='email'
                      type='text'
                      placeholder='Email...'
                      onChange={handleChange}
                      value={formData.email ?? ''}
                      sizing='md'
                      required
                    />
                  </div>
                </div>
              </div>
              <hr className='bg-gray-300 h-[2px]'></hr>
              <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] text-xl'>
                <div className='flex'>
                  <div className='px-1 content-center'>
                    {/* <MdSubscriptions style={iconstyle} /> */}
                  </div>
                  <div className='font-bold content-center'>Subject:</div>
                </div>
                <div className='flex'>
                  <div className='w-full'>
                    <TextInput
                      id='subject'
                      name='subject'
                      type='text'
                      placeholder='Subject...'
                      onChange={handleChange}
                      value={formData.subject ?? ''}
                      required
                      sizing='md'
                    />
                  </div>
                </div>
              </div>
              <hr className='bg-gray-300 h-[2px]'></hr>
              <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] text-xl'>
                <div className='flex'>
                  <div className='font-bold content-center'>
                    Questions/Comments:
                  </div>
                </div>
                <div>
                  <Textarea
                    id='questionsComments'
                    name='questionsComments'
                    //   type='text'
                    placeholder='Description...'
                    onChange={handleChangeTA}
                    value={formData.questionsComments ?? ''}
                    //   sizing='md'
                    rows={3}
                    required
                  />
                </div>
              </div>
              <hr className='bg-gray-300 h-[2px]'></hr>
            </div>
            <div className='flex justify-end pt-2'>
              <Button
                disabled={buttonDisabled}
                type='submit'
                className='buttonMain'
              >
                Submit
              </Button>
            </div>
          </form>
        </div>
        <div className='text-center'>
          {isLoading && <Loader />}
          {pageData?.description && renderHTML(pageData?.description)}
        </div>
      </div>
    </>
  );
}
